import { axiosInstances } from '../../../../utilities/axios/Instances/axios.instances';
const get = () => {
  return axiosInstances.withAuthToken().get('/employees/departments/');
};
export { get };
